import type { ProfileDTO } from '../api/types';
import type { OrganizationDataStatus, Profile } from '../model/types';

export const mapProfile = (profile: ProfileDTO): Profile => {
  return {
    ...profile,
    organizations: profile.organizations.map((organization) => ({
      ...organization,
      dataStatus: organization.dataStatus as OrganizationDataStatus,
    })),
  };
};
